import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class TiersService {
	constructor(private http: HttpClient) { }

	search(type: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:search',
			params: {
				type: type,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	relations(id: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:relations',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	setTiers(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:setTiers',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	setRelation(informations: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:setRelation',
			params: {
				informations: informations,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	disableTiers(idTiers: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:disableTiers',
			params: {
				idTiers: idTiers,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getTiersType(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:getTiersType',
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	searchTiersForSuivi(query: string, options: any = []): Observable<JSONRpcResponse> {

		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:searchTiersForSuivi',
			params: {
				query: query,
				options: options
			}
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	searchByType(typeID: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:searchByType',
			params: {
				typeID: typeID,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)

	}

    consultPlace(): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
            jsonrpc: '2.0',
            method: 'webservice.tiers:consultPlace',
            params: {
                
            },
        })
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }

	getProfessionsString(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:getProfessionsString',
			params: {
	
			}
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getTiersByConsultationType(
		typeID: any,
		options: any = []
	): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:getTiersByConsultationType',
			params: {
				typeID: typeID,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	searchTiersForVisite(term: string, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:searchTiersForVisite',
			params: {
				term: term,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	};

	list(search = null, types = null,no_limit:boolean=false): Observable<JSONRpcResponse> {
		
		
		let _options:any={
				search: search
			
		}
		
		if (no_limit)
			_options["nolimit"]=true;
		
		
		
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:list',
			params: {
				types: types || ['ADMIN', 'PMI'],
				options: _options
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	searchbyid(id: string): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:searchbyid',
			params: {
				id: id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	searchTiers(query: string, options?: any[]): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:searchTiers',
			params: {
				query: query,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	};

    modifTiers(id:string, options?: any[]): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:modifTiers',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	};

    modifDroits(id,droits: any[]): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:modifDroits',
			params: {
                id:id,
				droits: droits
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	};

    getTiersDroitsUser(userId: any,droitsCodes: any[]){
        let rpcMethod = new JSONRpc({
          jsonrpc: "2.0",
          method: "webservice.tiers:getTiersDroits",
          params: {
            id: userId,
            droitsCodes: droitsCodes
          }
        });
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    };

    getAdressesRelations(adresse: any, relations : any, tiersID: any): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
          jsonrpc: "2.0",
          method: "webservice.tiers:getAdressesRelations",
          params: {
            adresse : adresse,
			relations: relations,
            tiersID: tiersID
          }
        });
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    };

	getOptinStatus(dossierID: string): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:getOptinStatus',
			params: {
				dossierID: dossierID
			},
		});
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
	}
	
	getPrincipalStatus(dossierID: string): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.tiers:getPrincipalStatus',
			params: {
				dossierID: dossierID
			},
		});
		return this.http.post<JSONRpcResponse>(environment.webservice, rpcMethod);
	}
	
	getTiersList(search: string,options: any = []): Observable<any> {
	      let rpcMethod = new JSONRpc({
	          jsonrpc : "2.0",
	          method:"webservice.tiers:searchall",
	          params: {
				  search: search,
	              options: options
	          }
	      })
	      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
	  }
	//  groupeList(Array $types=[],$options=[])
	//getGroupe($id,$options=[])
	
	getGroupeList(types:string[] = [],options: any = []): Observable<any> {
	      let rpcMethod = new JSONRpc({
	          jsonrpc : "2.0",
	          method:"webservice.tiers:groupeList",
	          params: {
				  types: types,
	              options: options
	          }
	      })
	      return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
	 }
	 

	 getGroupe(id:any,options: any = []): Observable<any> {
	       let rpcMethod = new JSONRpc({
	           jsonrpc : "2.0",
	           method:"webservice.tiers:getGroupe",
	           params: {
	 			  id: id,
	              options: options
	           }
	       })
	       return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
	  }
	  
	  setGroupe(id:any,options: any = []): Observable<any> {
	  	       let rpcMethod = new JSONRpc({
	  	           jsonrpc : "2.0",
	  	           method:"webservice.tiers:setGroupe",
	  	           params: {
	  	 			  id: id,
	  	              options: options
	  	           }
	  	       })
	  	       return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
	  }
	  
	  connectByOpenID(): Observable<JSONRpcResponse> {
	  			let rpcMethod = new JSONRpc({
	  				jsonrpc: '2.0',
	  				method: 'webservice.tiers:connectByOpenID',
					params: {
					  	 			
					 }
	  			})
				
				
	  		return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
	  	}
}
